import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../../theme';
import { ChronosphereColorPalette, green } from '../colors';
import { buildPaletteForMode, type PaletteTokenMetadata, type Token } from '../panw-palette/token-metadata';

const successColorTokens = [
  { propertyPath: 'main', tokenName: '--semantic-data-informative-positive' },
  { propertyPath: 'highContrast', tokenName: '--data-informative-positive-high-contrast' },
  { propertyPath: 'lowContrast', tokenName: '--data-informative-positive-low-contrast' },
] satisfies Token[];

export const successColorMetadata: PaletteTokenMetadata = {
  componentName: 'status-success',
  tokens: successColorTokens,
};

export const successColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return buildPaletteForMode<ChronosphereColorPalette>(successColorTokens, mode);
  }
  return mode === 'light'
    ? {
        main: green[500],
        highContrast: green[700],
        lowContrast: green[100],
      }
    : {
        main: green[400],
        highContrast: green[100],
        lowContrast: green[800],
      };
};
